<template>
<v-card flat >

  <v-toolbar dense extended >
    <v-btn small icon
      @click='reload'
      :loading='servicesRequest.loading' ><v-icon>replay</v-icon></v-btn>
    <v-toolbar-title id="space-title" class='mr-2' >Spaces</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn outline outlined small @click='newspacedialog=true' >
      <v-icon>add</v-icon> New space
    </v-btn>
    <!-- <v-btn outline outlined small @click='showProductSheet=true' >
      Products
    </v-btn> -->
    <!-- <product-sheet :visible='showProductSheet' /> -->

    <template slot='extension' >
      <v-btn small flat color='primary' class='mr-0'
        @click='$vuetify.goTo("#space-" + service.id)'
        v-for='service in services'
        :key='service.id' >{{service.title}}</v-btn>
    </template>

  </v-toolbar>

  <v-dialog v-model='newspacedialog' width='400' >
    <v-card>
      <request-status :request='servicesNewRequest' @ok='newSpaceCreated' />
      <v-card-title class='grey lighten-4 py-0' >
        Create a new space
        <v-spacer/>
        <v-btn @click='newspacedialog=false' icon ><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field label='Give this space a name' v-model='spacetitle' @keypress.enter='newService' />
      </v-card-text>
      <v-card-actions >
        <v-btn @click='newspacedialog=false' flat >Cancel</v-btn>
        <v-spacer/>
        <v-btn @click='newService' color='primary' :loading='servicesNewRequest.loading' >
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <request-status :request='servicesRequest' :message200='false' @ok='newspaceloading=false' />

  <!-- new space placeholder -->
  <!-- <v-card class='ma-3' v-if='newspaceloading' >
    <v-card-title
      class='title pl-4 white--text'
      style="background-color: rgba(0, 0, 0, 0.6);" >
      {{spacetitle}}
    </v-card-title>
    <v-card-text class='pa-5' >
      <center>
      <v-progress-circular color='amber' class='ma-2' width='2' :size='70' indeterminate /><br/>
      Loading settings ..
      </center>
    </v-card-text>
  </v-card> -->

  <v-layout row wrap class='mt-2' >
    <v-flex xs12 xl6
      v-for='(service, index) in services'
      :key='service.id' >
      <!-- ID-{{service.id}} -->
      <space-settings
        v-model="services[index]"
        :initially-expanded="services.length === 1"
        :key='service.id' :id='`service-${service.id}`'
        class='mb-5'
        @reload='reload' />
    </v-flex>
  </v-layout>
  <!-- <vuex-loader :request-id='requests.service.list' ></vuex-loader> -->

</v-card>
</template>

<script>
import SpaceSettings from './SpaceSettings.vue'
import ProductSheet from '@/components/pickers/ProductSheet.vue'
export default {
  name: 'ProductWizard',
  components: {
    SpaceSettings,
    ProductSheet
  },
  data () {
    return {
      gotoSpace: null,
      showProductSheet: false,
      newspacedialog: false,
      newspaceloading: false,
      spacetitle: null,
      requests: {
        practitioner: 'practitioner-get-request',
        service: {
          new: 'new-service-request',
          list: {
            // resource: 'ag.spaces.practitioner'
            resource: 'ag.spaces.practitioner.v2'
          }
        }
      }
    }
  },
  watch: {
    servicesRequestStatus () {
      console.log(this.servicesRequestStatus)
      if (this.servicesRequestStatus === 200) {
        if (this.gotoSpace) {
          window.setTimeout(() => {
            let anchor = '#space-' + this.gotoSpace
            this.$vuetify.goTo(anchor)
            this.gotoSpace = null
          }, 500)
        }
      }
    }
  },
  computed: {
    servicesRequest () {
      return this.requests.service.list
    },
    servicesRequestStatus () {
      return this.servicesRequest.status
    },
    services () {
      return this.getObjectPath(this.requests.service.list, 'result.results', [])
    },
    servicesNewRequest () {
      return this.$store.getters.getRequestById(this.requests.service.new, true)
    }
  },
  mounted () {
    // this.selectedPractitionerId = this.practitioner.id
    this.reload()
    // this.$appointmentguru.resource('practitioner').id(this.requests.practitioner).get(this.practitionerId)
  },
  methods: {
    reload () {
      this.$request('get', this.requests.service.list)
      this.refreshGlobalSettings()
      // this.$appointmentguru.resource('practitioner.services').id(this.requests.service.list).list()
    },
    newService () {
      let options = { id: this.requests.service.new }
      options.data = {name: this.spacetitle}
      this.$appointmentguru.endpoint('location.touch', options)
    },
    newSpaceCreated (result) {
      this.reload()
      this.newspacedialog = false

      let id = this.getObjectPath(result, 'result.data.id')
      if (id) { this.gotoSpace = id }
    },
    logout () {
      this.$store.dispatch('LOGOUT')
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductWizard.vue?14acd85d